module.exports = __webpack_public_path__ + "files/b05ac1194f78ee1d7a97b475fe86ca4e.png";